module.exports = __webpack_public_path__ + "static/media/blueberry.c01687b4.png";